export function PersonFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M12 13c2 0 5-2.462 5-5.5S14.762 2 12 2C9.24 2 7 4.462 7 7.5s3 5.5 5 5.5zM10.582 14a5.99 5.99 0 00-5.846 4.69l-.302 1.359A1.603 1.603 0 005.999 22H18.23a1.42 1.42 0 001.386-1.728l-.264-1.187A6.493 6.493 0 0013.014 14h-2.432z"
      ></path>
    </svg>
  );
}
